import { render, staticRenderFns } from "./VaultingPage.vue?vue&type=template&id=6130fec6&scoped=true"
import script from "./VaultingPage.vue?vue&type=script&lang=js"
export * from "./VaultingPage.vue?vue&type=script&lang=js"
import style0 from "./VaultingPage.vue?vue&type=style&index=0&id=6130fec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6130fec6",
  null
  
)

export default component.exports